export type TrackerOrderByEnum = typeof TrackerOrderByEnum[keyof typeof TrackerOrderByEnum]

/**
 * 이벤트 트래커에서 sort_by 속성에 넣는 값
 * @url {https://www.notion.so/industrious-ethernet-850/sort_by-1b3a62d2e0b54406a6ab5eb4bbf74712?pvs=4}
 */
export const TrackerOrderByEnum = {
  /** Recommend - 추천순 */
  Recommend: 'recommend',
  /** Popular - 인기 판매순 */
  Popular: 'popular',
  /** Recent - 최신순 */
  Recent: 'recent',
  /** LowPrice - 낮은 가격순 */
  LowPrice: 'low',
  /** HighPrice - 높은 가격순 */
  HighPrice: 'high',
  /** Discount - 할인율 순 */
  Discount: 'discount',
  /** Review - 리뷰 많은 순 */
  Review: 'review',
  /** MD - MD 추천순 */
  MD: 'MD',
  /** 별점순  */
  ReviewScore: 'starred',
} as const
